import { render, staticRenderFns } from "./Order_customer_main.vue?vue&type=template&id=9814c46a&scoped=true&"
import script from "./Order_customer_main.vue?vue&type=script&lang=js&"
export * from "./Order_customer_main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9814c46a",
  null
  
)

export default component.exports